// Gate B — Registrar resultado HUMANO de una llamada manual a un contacto configurado.
// El contacto viene PRESELECCIONADO/BLOQUEADO desde la fila donde se abrió. No cambia el caso.
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const RESULTADO_GESTION = [
  { v: "contactado", l: "Contactado" },
  { v: "no_contesto", l: "No contestó" },
  { v: "buzon", l: "Buzón / correo de voz" },
  { v: "numero_equivocado", l: "Número equivocado" },
  { v: "acudira_en_sitio", l: "Acudirá en sitio" },
];

export const MOTIVO_GESTION = [
  { v: "caida", l: "Caída" },
  { v: "salida_cama", l: "Salida de cama" },
  { v: "alerta_signos_vitales", l: "Alerta de signos vitales" },
  { v: "otro", l: "Otro" },
];

export default function RegistrarResultadoModal({ open, onOpenChange, contacto, onConfirm, submitting }) {
  const [resultado, setResultado] = useState("");
  const [motivo, setMotivo] = useState("");
  const [nota, setNota] = useState("");

  const submit = async () => {
    if (!resultado) return;
    const r = await onConfirm({ resultado, motivo: motivo.trim(), nota: nota.trim() });
    // REPARACIÓN M6-C — los campos sólo se vacían con CONFIRMACIÓN acreditada. Un rechazo 400 o una
    // respuesta incierta conservan resultado, motivo y nota para que el humano decida.
    if (r && r.estado && !String(r.estado).startsWith("confirmado")) return;
    setResultado(""); setMotivo(""); setNota("");
  };
  const cerrar = (v) => { if (!v) { setResultado(""); setMotivo(""); setNota(""); } onOpenChange(v); };

  return (
    <Dialog open={open} onOpenChange={cerrar}>
      <DialogContent data-testid="registrar-resultado-modal" className="sm:max-w-md">
        <DialogHeader><DialogTitle>Registrar resultado de contacto</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="rounded-lg bg-slate-50 px-3 py-2 text-sm">
            <span className="text-slate-400">Contacto:</span>{" "}
            <span data-testid="gestion-contacto-nombre" className="font-semibold text-slate-700 dark:text-slate-100">
              {contacto?.nombre || "—"}{contacto?.relacion ? ` · ${contacto.relacion}` : ""}
            </span>
          </div>
          <div>
            <Label className="text-xs">Resultado *</Label>
            <div className="mt-1.5 flex flex-wrap gap-1.5">
              {RESULTADO_GESTION.map((r) => (
                <button key={r.v} type="button" data-testid={`gestion-resultado-${r.v}`}
                  onClick={() => setResultado(r.v)}
                  className={`rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${
                    resultado === r.v ? "border-[#01CBE3] bg-[#01CBE3]/15 text-[#0891A6]" : "border-slate-200 text-slate-500 hover:border-[#01CBE3]"}`}>
                  {r.l}
                </button>
              ))}
            </div>
          </div>
          <div>
            <Label className="text-xs">Motivo (opcional)</Label>
            <div className="mt-1.5 flex flex-wrap gap-1.5">
              {MOTIVO_GESTION.map((m) => (
                <button key={m.v} type="button" data-testid={`gestion-motivo-${m.v}`}
                  onClick={() => setMotivo(motivo === m.v ? "" : m.v)}
                  className={`rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${
                    motivo === m.v ? "border-[#012472] bg-[#012472]/10 text-[#012472] dark:text-[#80B3FF]" : "border-slate-200 text-slate-500 hover:border-[#012472]"}`}>
                  {m.l}
                </button>
              ))}
            </div>
          </div>
          <div>
            <Label className="text-xs">Nota (opcional)</Label>
            <Textarea data-testid="gestion-nota" value={nota} onChange={(e) => setNota(e.target.value)} rows={2} placeholder="Detalle de la conversación" className="mt-1 rounded-lg" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => cerrar(false)}>Cancelar</Button>
          <Button data-testid="gestion-guardar" onClick={submit} disabled={!resultado || submitting} className="bg-[#01CBE3] text-[#012472] hover:bg-[#01B5CB]">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
